
























import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { Permission } from "@/shared/types";
import * as routes from "@/admin/route-names";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component
export default class PartnerUserBulkActions extends Vue {
  custodianSettingStore = useCustodianSettingsStore();
  rolePermissionsStore = useRolePermissionsStore();

  routes = routes;
  activeTab = null;

  mounted (): void {
    this.activeTab = this.$route.name;

    if (this.activeTab === routes.PartnerUserBulkActions) {
      this.goToMassAdd();
    }
  }

  @Prop()
  routeToMassAdd;

  @Prop()
  routeToMassDelete;

  goToMassAdd (): void {
    this.$router.push(this.routeToMassAdd);
  }
  goToMassDelete (): void {
    this.$router.push(this.routeToMassDelete);
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName
    });
  }

  get displayMassAddLink (): boolean {
    return true;
  }

  get displayMassDeleteLink (): boolean {
    return true;
  }
}

